import React from 'react'

export default function ErrorPage() {
  return (
    <div className='flex bg-[#F6F9FE] w-full h-screen text-center justify-center items-center font-black text-4xl'>
        404 NOT FOUND
    </div>
  )
}
